import Toggle from "../../util/toggle";

function SelectBlock() {

    if (document.querySelector('.selectblock') !== null) {
        this.init();
    }

}

SelectBlock.prototype.init = function () {

    var toggle = new Toggle('.selectblock__header', '.selectblock ul', 'clicked', 'show', false, true),
        select_blocks = document.querySelectorAll('.selectblock.js')
        ;

    if (select_blocks !== null) {
        for (var i = 0; i < select_blocks.length; i++) {
            let select_block = select_blocks[i];
            let select_block_header = select_block.querySelector('.selectblock__header');
            let select_block_options = select_block.querySelector('.selectblock__options');
            // this.list_width(select_block);
            document.addEventListener('click', function(event) {
                if (event.target.tagName != 'LI' && event.target != select_block_header) {
                    if (select_block_header !== null && select_block_options !== null && select_block_header.classList.contains('clicked')) {
                        select_block_header.classList.remove('clicked');
                        select_block_options.classList.remove('show');
                    }
                }
            });
        }
    }
 
}

SelectBlock.prototype.list_width = function (elem) {

    // get width of widest list item and set parent to that width

    if (window.innerWidth >= 600) {

        var lists = elem.querySelectorAll('ul li'),
            list,
            biggestWidth;

        if (lists !== null) {
            biggestWidth = 0;
            for (var i = 0; i < lists.length; i++) {

                list = lists[i];
                if (list.offsetWidth > biggestWidth) {
                    biggestWidth = list.offsetWidth;
                }
            }
            elem.style.width = biggestWidth + "px";

        }

    }
}

export default SelectBlock;


// WEBPACK FOOTER //
// ./js/components/selectblock/index.js